import { gql, useQuery } from "@apollo/client";
import Errors from "components/base/Errors";
import Spinner from "components/base/Spinner";
import { useParams } from "react-router-dom";
import CommercialInvoiceForm from "./Form";

const FETCH_CREATE_COMMERCIAL_INVOICE_DATA = gql`
  query FETCH_CREATE_COMMERCIAL_INVOICE_DATA($id: ID!) {
    commercialInvoiceShipment(id: $id) {
      id
      invoiceNumber
      po
      odooCurrency
      customer {
        system
      }
      countryOfOrigin
      shipmentConsigneeName
      addr
      deliveryAddr
      shipmentNotifyPartyName
      notifyParty
      shippingMark
      blNumber
      vv
      containerNumber
      shippingTerm
      loadingPort
      shipTo
      portOfDestination
      shipmentInvoices {
        id
        pos {
          id
          number
        }
        invoice {
          number
        }
        shipmentInvoiceRows {
          id
          purchaseOrder {
            id
            number
          }
          packingName
          itemNumber
          hsCodeForDestination
          qty
        }
      }
      totalQty
    }
  }
`;

function GenerateCommercialInvoice() {
  const { id } = useParams();

  const { loading, error, data } = useQuery(
    FETCH_CREATE_COMMERCIAL_INVOICE_DATA,
    {
      variables: { id },
      fetchPolicy: "network-only",
    },
  );
  if (error) return <Errors error={error} />;
  if (loading) return <Spinner />;

  const { commercialInvoiceShipment: shipment } = data;

  return <CommercialInvoiceForm initialShipment={shipment} />;
}

export default GenerateCommercialInvoice;
